import React from "react";

/**
 * A component for safely rendering HTML content
 * @param {string} html - HTML string to render
 * @param {string} className - Additional CSS classes
 * @param {object} ...props - Other div props
 */
export default function SafeHtml({ html, className = "", ...props }) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      className={className}
      {...props}
    />
  );
}
